import { DictionaryHelper } from '@/helpers/dictionary.helper';
import { PropertyHelper } from '@/helpers/property.helper';
import { UserHelper } from '@/helpers/user.helper';
import { DictionaryCacheService } from '@/services/dictionary-cache.service';
import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Attribute, PhotosService, PropertyAttribute, RealProperty, RescueService } from '@eemo/api-client';
import { PropertyDocViewComponent } from '../../../components/property-doc-view/property-doc-view.component';
import { PropertyPeopleTableComponent } from '../../../components/property-people-table/property-people-table.component';

import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { NgFor } from '@angular/common';

@Component({
    selector: 'app-property-rescue',
    templateUrl: './property-rescue.component.html',
    styleUrls: ['./property-rescue.component.scss'],
    standalone: true,
    imports: [NgFor, MatIconModule, MatExpansionModule, PropertyPeopleTableComponent, PropertyDocViewComponent]
})
export class PropertyRescueComponent implements OnInit {
  @Input() prop: RealProperty;

  rescueAttrsDict: Attribute[];
  rescueAttrs: { [key: string]: PropertyAttribute } = {};

  alerts: string[] = [];

  mainPhoto: SafeUrl;
  UserHelper = UserHelper;

  constructor(
    private rescueService: RescueService,
    private photoService: PhotosService,
    public propertyHelper: PropertyHelper,
    public userHelper: UserHelper,
    public dictCacheService: DictionaryCacheService,
    public dictHelper: DictionaryHelper,
    private domSanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.rescueAttrsDict = this.dictCacheService
      .getAttributesForRescue()
      .filter((a) => !a.allowedPropertyTypes || a.allowedPropertyTypes.indexOf(this.prop.type) > -1);
    this.rescueService.getRealPropertyRescueAttributes(this.prop.uid).subscribe((data) => {
      data.forEach((attrValue) => {
        if (attrValue.code === 'FIRST_HEATING_NATURE' && attrValue.value === 'FIRST_HEATING_NATURE_GAZ') {
          this.alerts.push('Installation Gaz');
        } else if (attrValue.code === 'FIRST_HEATING_NATURE' && attrValue.value === 'FIRST_HEATING_NATURE_FUEL') {
          this.alerts.push('Installation Fuel');
        } else if (
          (attrValue.code === 'BUILDING_TYPE' && attrValue.value === 'WOOD') ||
          (attrValue.code === 'WALLS' && attrValue.value === 'WALLS_WOODFRAME')
        ) {
          if (this.alerts.indexOf('Structure Bois') === -1) {
            this.alerts.push('Structure Bois');
          }
        }
        this.rescueAttrs[attrValue.code] = attrValue;
      });
    });
    this.mainPhoto = this.propertyHelper.getEmptyMainPhotoImage();
    this.photoService.getMainPhotoImage(this.prop.uid, '640x360', this.prop.mainPhotoTs).subscribe((photo) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        this.mainPhoto = this.domSanitizer.bypassSecurityTrustUrl(reader.result.toString());
      };
      reader.readAsDataURL(photo);
    });
  }
}
